window.addEventListener("DOMContentLoaded", (event) => {
 
    let tabBtns = document.querySelectorAll('.product-tabination .tablinks');
    if (tabBtns) {
      let tabContent = document.querySelectorAll('.tab-description .tabcontent');
      tabBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          tabBtns.forEach(btn => btn.classList.remove('active'))
          tabContent.forEach(btn => btn.classList.remove('active'))
          e.currentTarget.classList.add('active');
          let targetID = e.currentTarget.dataset.id;
          tabContent.forEach(tab => {
            if (tab.id == targetID) {
              tab.classList.add('active');
            } else { 
              tab.classList.remove('active')
            }
          })
          
        })
      })
    }
  });
  
  